export const REGEX_CONSTANTS = {
  JSON_MATCH: /(\[[\s\S]*\]|\{[\s\S]*\})/,
};
